import React, { useState } from 'react';
import Nav from '../../components/Nav/Nav';
import signup_pic from './assets/signup_pic.jpg';
import google from './assets/google.svg';
import Footer from '../../components/Footer/Footer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import baseUrl from '../../components/baseUrl'
import VerifyOTP from '../../components/VerifyOTP/VerifyOTP'
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    confirmPassword: ''
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmpasswordVisible, setconfirmPasswordVisible] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState('');
  const [error, setError] = useState('');
  const [signUpSuccess, setSignUpSuccess] = useState(false);
  const [correctOtp, setCorrectOtp] = useState('')
  const [email, setEmail] = useState("")
  const [userType, setUserType] = useState('');
  const [loading, setLoading] = useState(false); // Track loading state
  const [roleError, setRoleError] = useState('');

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const toggleconfirmPasswordVisibility = () => {
    setconfirmPasswordVisible(!confirmpasswordVisible);

  };

  const handleGoogleLogin = () => {
    // Backend should redirect to: https://your-frontend.com/auth/callback?token=...
    window.location.href = `${baseUrl}/social-auth/google`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === 'email') {
      setEmail(value);
    }

    if (name === 'password') {
      checkPasswordStrength(value);
    }
  };

  const checkPasswordStrength = (password) => {
    if (password.length < 6) {
      setPasswordStrength('Weak');
    } else if (password.length < 10) {
      setPasswordStrength('Medium');
    } else {
      setPasswordStrength('Strong');
    }
  };

  const handleSubmit = async (e) => {
    setError('');
    setRoleError('');
    setLoading(true); // Set loading to true when the request starts

    if (!userType) {
    setRoleError('Please select whether you are a User or Vendor!');
    setLoading(false);
    return;
  }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      // Combine all form data and the selected userType
const payload = {
  ...formData,
  user_type: userType || "user" // default to "user" if none selected
};

const response = await axios.post(`${baseUrl}/auth/register`, payload);


      if (response.data.success) {
        // User has successfully signed up and needs to verify account using OTP
        setSignUpSuccess(true);
        setCorrectOtp(response.data.otpCode);
      }

    } catch (err) {
      if (err.response) {
        // Handle the error message from the server
        if (err.response.status === 400 && err.response.data.msg === "User already exists") {
          setError("User already exists");
        } else {
          setError(err.response.data.msg || 'Signup failed. Please try again.');
        }
      } else {
        setError('Signup failed. Please try again.');
      }
    }
    finally {
      setLoading(false); // Set loading to false after request is completed
    }
  };


  return (
    <div className='lg:min-h-screen flex flex-col justify-between'>
      <Nav />

      <div className={`flex flex-col-reverse lg:flex-row  items-center   ${signUpSuccess ? 'lg:pt-[16vh] mg:pt-[14vh]':'lg:items-start lg:pt-[22vh] mg:pt-[22vh]'} lg:justify-between lg:gap-[56px] mg:gap-[60px] xl:gap-[122px] pt-[95px] sm:pt-[112px] lg:pb-16  lg:pl-[64px] mg:pl-[102px] xl:pl-[151px]`}>

        {/* start */}

        <div className='lg:flex-1 lg:flex lg:justify-center lg:items-center self-center bg-white lg:bg-none rounded-t-[30px] sm:rounded-t-[40px] left-0 right-0 px-[24px] sm:px-[132px] pt-[37px]  pb-[35px] lg:pb-0 sm:pt-[67px] lg:pt-0 lg:px-0 absolute bottom-0 lg:relative h-[65vh] sm:h-[56vh] lg:h-auto max-h-[calc(100vh-100px)] lg:max-h-none overflow-y-auto lg:overflow-y-visible z-20 w-full lg:w-min-[700px] shadow-input lg:shadow-none'>

          {signUpSuccess ? (<VerifyOTP verifyType="register" correctOtp={setCorrectOtp} email={email} />
          ) :
            (
              <div className='w-full flex flex-col gap-[10px] lg:gap-[15px] items-center bg-white lg:bg-none rounded-t-[30px] sm:rounded-t-[40px] left-0 right-0 px-[24px] sm:px-[132px] pt-[37px]  pb-[35px] sm:pt-[67px] lg:pt-0 lg:pb-0 xl:pb-0 lg:px-0 absolute bottom-0 lg:relative h-[65vh] sm:h-[56vh] lg:h-auto max-h-[calc(100vh-100px)] lg:max-h-none overflow-y-auto lg:overflow-y-visible z-20 w-full lg:w-min-[700px] shadow-input lg:shadow-none'>
                 <button onClick={handleGoogleLogin} className='w-full h-[40px] md:h-[50px] shrink-0 border-[1px] border-ravgray1 rounded-[80px] flex items-center justify-center'>
                  <img src={google} alt='' />
                  <h1 className='text-ravinput text-base lg:text-sm font-bold ml-[9px] lg:ml-[13px]'>Sign in with Google</h1>
                </button> 
                <h1 className='font-bold mb-[7px] lg:my-[14px] text-ravinput text-xs lg:text-[16px]'> SIGN UP WITH EMAIL</h1>
                <div className='w-full'>
                  {error && <p className='text-[#EB0728] mb-[10px] text-[10px] leading-[12.13px]  pl-[20px]  md:pl-[23px] lg:pl-[29px]'>{error}</p>}

                  <input type='email' name='email' value={formData.email} onChange={handleChange} placeholder='Email' required className='font-medium px-[20px] md:px-[23px] lg:px-[29px] h-[45px] md:h-[50px] shrink-0 w-full rounded-[80px] placeholder:text-ravinput  text-base bg-ravbg outline-ravblue' />
                </div>
                <div className='names w-full flex sm:flex-col md:flex-row gap-[7px] md:gap-[16px] xl:gap-[12px]'>
                  <input type='text' name='first_name' value={formData.first_name} onChange={handleChange} placeholder='First name' required className='font-medium  px-[20px] md:px-[23px] lg:px-[29px] h-[45px] md:h-[50px] w-full rounded-[80px] placeholder:text-ravinput  text-base bg-ravbg outline-ravblue' />
                  <input type='text' name='last_name' value={formData.last_name} onChange={handleChange} placeholder='Last name' required className='font-medium  px-[20px] md:px-[23px] lg:px-[29px] h-[45px] md:h-[50px] w-full rounded-[80px] placeholder:text-ravinput  text-base bg-ravbg outline-ravblue' />
                </div>


                <div className='relative w-full'>

                  <input type={passwordVisible ? 'text' : 'password'} name='password' value={formData.password} onChange={handleChange} placeholder='New password' required className='shrink-0 pl-[20px] font-medium   md:pl-[23px] lg:pl-[29px] pr-[50px] h-[45px] md:h-[50px] w-full rounded-[80px] placeholder:text-ravinput  text-base bg-ravbg outline-ravblue' />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute absolute right-5 top-3 flex items-center text-sm "
                  >
                    {passwordVisible ? (
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" className="fill-[#AAAAAA]">
                        <path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        className="fill-[#AAAAAA]">
                        <path
                          d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
                      </svg>
                    )}
                  </button>

                  {/* <p className='text-xs text-ravinput'>{passwordStrength}</p> */}
                </div>

                <div className='relative w-full'>

                  <input type={confirmpasswordVisible ? 'text' : 'password'} name='confirmPassword' value={formData.confirmPassword} onChange={handleChange} placeholder='Confirm password' required className='shrink-0 pl-[20px] font-medium  md:pl-[23px] lg:pl-[29px] h-[45px] md:h-[50px] w-full rounded-[80px] placeholder:text-ravinput  text-base bg-ravbg outline-ravblue' />
                  <button
                    type="button"
                    onClick={toggleconfirmPasswordVisibility}
                    className="absolute absolute right-5 top-3 flex items-center text-sm "
                  >
                    {confirmpasswordVisible ? (
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" className="fill-[#AAAAAA]">
                        <path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        className="fill-[#AAAAAA]">
                        <path
                          d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
                      </svg>
                    )}
                  </button>
                </div>
 {/* Heading */}
  <h2 className="font-bold text-[12px] text-[#707070] mt-[27px] font-satoshi">
   SELECT THE OPTION THAT BEST DESCRIBES YOU
  </h2>
              {/* Role Selection */}
<div className="w-full h-[162px] md:h-[157px] lg:h-[165px] xl:h-[162px] border border-rateavendorLightGray rounded-[15px] flex flex-col items-start justify-evenly mb-[22px] py-2.5 px-4">

  {/* USER OPTION */}
  <div className="flex flex-col items-start w-full ">
    <label
      className={`flex items-center p-1 space-x-2 w-full transition
      ${userType === "user" ? "bg-rateavendorLightBlue/10" : ""}`}
    >
      <input
        type="radio"
        name="user_type"
        value="user"
        checked={userType === "user"}
        onChange={(e) => setUserType(e.target.value)}
        className="accent-rateavendorBlue w-[22px] h-[22px] cursor-pointer"
      />
      <span className="font-bold font-satoshi text-[16px] text-black">
        User
      </span>
    </label>
  <p className="text-[14px] font-medium font-satoshi text-[#AAAAAA] ml-[37px] leading-snug">
      I'm here to discover trusted vendors for my events.
    </p>
  </div>

  {/* VENDOR OPTION */}
  <div className="flex flex-col items-start w-full">
    <label
      className={`flex items-center p-1 space-x-2 w-full transition
      ${userType === "vendor" ? "bg-rateavendorLightBlue/10" : ""}`}
    >
      <input
        type="radio"
        name="user_type"
        value="vendor"
        checked={userType === "vendor"}
        onChange={(e) => setUserType(e.target.value)}
        className="accent-rateavendorBlue w-[22px] h-[22px] cursor-pointer"
      />
      <span className="font-bold font-satoshi text-[16px] text-black">
        Vendor
      </span>
    </label>
    <p className="text-[14px] font-medium  font-satoshi text-[#AAAAAA] ml-[40px] leading-snug">
      I'm here to list my services and reach new clients.
    </p>
  </div>
</div>

{roleError && <p className='text-[#EB0728] mb-[10px] text-[10px] leading-[12.13px]  pl-[20px]  md:pl-[23px] lg:pl-[29px]'>{roleError}</p>}



                <button onClick={handleSubmit} disabled={loading} className={`shrink-0 mt-[8px] ${loading ? 'bg-[#A2CEFF]' : ' bg-ravblue'} text-[#FFFFFF] text-[16px] font-bold w-full h-[45px] md:h-[50px] rounded-[80px] flex items-center justify-center`}>
                  {/* Spinner overlay */}
                  {loading ? (
                    <AiOutlineLoading3Quarters className="absolute animate-spin" />)

                    : (<span>
                      Sign up
                    </span>
                    )}
                </button>

                <h1 className='text-[#707070] text-xs sm:text-base font-medium'>Already have an account? <button onClick={() => navigate('/login')} className='text-ravblue font-bold'>Login</button></h1>
                <h1 className=' text-ravinput text-xs sm:text-base font-medium text-center'>By signing up you agree to our <button onClick={() => navigate("/signup")} className=' hover:text-opacity-70 text-ravblue font-bold transform transition-all ease-in-out duration-300'>Terms of Service
                  & Privacy Policy</button></h1>

              </div>
            )}
        </div>


        {/* image start */}

        {/* <div className='lg:flex sm:flex-1 px-[24px] w-auto sm:px-[32px] lg:px-0 lg:w-auto'>
          <img src={signup_pic} alt='signup_pic' className='w-full relative z-10 object-cover rounded-t-[20px] sm:rounded-t-[50px] lg:rounded-l-[50px] lg:rounded-r-none' />
        </div> */}
        <div className={`lg:flex sm:flex-1 px-[24px] w-auto sm:px-[32px] lg:px-0 lg:w-auto  ${signUpSuccess?'lg:min-h-[50vh]':'lg:min-h-[90vh]'} lg:min-w-[504px] mg:min-w-[567px] xl:min-w-[664px]`}>
          <img
            src={signup_pic}
            alt="signup_pic"
            className={` w-full  relative z-10 object-cover rounded-t-[20px] sm:rounded-t-[50px] lg:rounded-l-[50px] lg:rounded-r-none  sm:max-h-screen ${signUpSuccess ? 'xl:max-h-[72vh]':'xl:max-h-[92vh]'}  `}
          />
        </div>
      </div>
      <div className='hidden lg:hidden'>
        <Footer />
      </div>
    </div>

  );
};

export default Signup;
